import { Youtube, Mail } from "lucide-react";
import YmfLogo from "./YmfLogo";
import { goTo } from "../lib/scroll";

const LINKS = [
  { id: "#que-es", label: "¿Qué es la lectura fácil?" },
  { id: "#comparador", label: "Antes y después" },
  { id: "#podcast", label: "Vídeo podcast" },
  { id: "#equipo", label: "Equipo" },
  { id: "#contacto", label: "Contacto" },
];

export default function Footer() {
  const go = (e, id) => {
    e.preventDefault();
    goTo(id);
  };
  return (
    <footer className="bg-[#14161a] text-[#f6f1e6] py-14">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid md:grid-cols-[1.2fr_0.8fr] gap-10">
        <div>
          <div className="flex items-center gap-3">
            <YmfLogo size={52} withWink={false} stroke="#f6f1e6" />
            <span className="font-hand text-3xl">Ye muy fácil</span>
          </div>
          <p className="mt-4 max-w-md text-base leading-relaxed text-[#c9cfd6]">
            Traducimos textos difíciles a lectura fácil. Porque entender es un derecho, y hacerlo posible es tan sencillo como hacerlo muy fácil.
          </p>
          <div className="flex flex-wrap gap-4 mt-6">
            <a
              href="https://www.youtube.com/watch?v=i4ceFizLb-0"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-youtube"
              className="inline-flex items-center gap-2 text-sm font-bold hover:text-[var(--yellow)] transition-colors"
            >
              <Youtube className="w-5 h-5" aria-hidden="true" />
              YouTube
            </a>
            <a
              href="mailto:info@bilbaobianco.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-sm font-bold hover:text-[var(--yellow)] transition-colors"
            >
              <Mail className="w-5 h-5" aria-hidden="true" />
              info@bilbaobianco.com
            </a>
          </div>
        </div>
        <nav aria-label="Enlaces del pie de página" className="flex flex-col gap-3">
          {LINKS.map((l) => (
            <a key={l.id} href={l.id} data-testid={`footer-link-${l.id.slice(1)}`} onClick={(e) => go(e, l.id)} className="text-base font-bold hover:text-[var(--yellow)] transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="max-w-6xl mx-auto px-5 md:px-8 mt-12 pt-6 border-t border-[#3a3f47] flex flex-col md:flex-row gap-3 justify-between text-sm text-[#c9cfd6]">
        <p>© {new Date().getFullYear()} Ye muy fácil · Pola de Siero y Langreo, Asturias</p>
        <p data-testid="footer-trademark" className="font-bold text-[var(--yellow)]">Marca en proceso de registro</p>
        <p>Escrita en lectura fácil, claro está.</p>
      </div>
    </footer>
  );
}
